<template>
    <div>
        <div class="navtit">
            {{$t('home.nav3')}}
        </div>
        <div class="banner">
            <img src="../assets/1.png" alt="">
        </div>
        <div class="container">
            <el-row :gutter="50" style="width: 800px;margin:0 auto;">
            <el-col :span="8">
                <div :class="['descript-item',index == '1' ? 'active' : '']" @click="getTabs('1')">
                <div class="descript-item-top">{{$t('item3.tit1')}}</div>
                </div>
            </el-col>
            <el-col :span="8">
                <div :class="['descript-item',index == '2' ? 'active' : '']" @click="getTabs('2')">
                <div class="descript-item-top">{{$t('item3.tit2')}}</div>
                </div>
            </el-col>
            <el-col :span="8">
                <div :class="['descript-item',index == '3' ? 'active' : '']" @click="getTabs('3')">
                <div class="descript-item-top">{{$t('item3.tit3')}}</div>
                </div>
            </el-col>
            </el-row>
            <el-divider></el-divider>
            <!-- 概览 -->
            <div class="file-con" v-if="index == '1'">
                <p v-html="Richtext"></p>
            </div>
            <!-- 治理文件 -->
            <div v-if="index == '2'" style="margin-top:50px;">
              <el-row :gutter="50">
                <el-col :span="12" v-for="(item,index) in zhiliList" :key="index">
                  <div class="notice-item">
                    <a :href="item.FilePath" target="_blank">
                      <div class="notice-item-left">
                        <div class="notice-desc">{{item.Title}}</div>
                        <div class="notice-desc1">{{item.CerTime}}</div>
                      </div>
                      <div class="notice-item-right"></div>
                    </a>
                  </div>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
            </div>
            <!-- 管理团队 -->
            <div class="yeji" v-if="index == '3'">
                <div class="tuanduiBox" v-for="item,index in tuanduiList.zc" :key="index">
                    <div class="tuanduiTit" >{{item}}</div>
                    <div class="tuanduiTxt">
                        <p v-for="item1,index in tuanduiList.dsh.filter(x => x.Title==item)" :key="index">{{item1.Name}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      index: '1',
      Richtext: '',
      zhiliList: [],
      tuanduiList: {}
    }
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      console.log(newVal, oldVal)
      this.getList()
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getTabs (e) {
      this.index = e
      this.getList()
    },
    getList () {
      const that = this
      let url = ''
      let t = ''
      // eslint-disable-next-line eqeqeq
      if (localStorage.getItem('locale') === 'en') {
        url = '/Front_Index/Main/GetDataEn'
      } else if (localStorage.getItem('locale') === 'cn') {
        url = '/Front_Index/Main/GetData'
        t = 0
      } else if (localStorage.getItem('locale') === 'mo') {
        url = '/Front_Index/Main/GetData'
        t = 1
      }
      const obj = {
        type: that.index === '1' ? 4 : (that.index === '2' ? 6 : (that.index === '3' ? 5 : '')),
        t: t
      }
      console.log(url)
      this.$axios.post(url, obj).then(response => {
        console.log(response)
        if (that.index === '1') {
          that.Richtext = response.data.Richtext
        }
        if (that.index === '2') {
          that.zhiliList = response.data
        }
        if (that.index === '3') {
          that.tuanduiList = response.data
        }
      })
    }

  }
}
</script>
  <style scoped>
  .el-divider--horizontal{
    margin: 0;
  }
  .navtit{
  font-size: 36px;
    color: #000000;
    line-height: 45px;
    text-align: center;
    padding: 30px 60px;
}
.banner{
  width: 100%;
  height: 540px;
  margin: 0 auto;
  overflow: hidden;
}
.banner img{
  width: 100%;
  height: 100%;
}
  .container {
    width: 1050px;
    margin: 0 auto;
    padding: 80px 0;
  }
  .descript-item {
    background-color: #f7f7f7;
    width: 100%;
    height: 40px;
    /* border-radius: 5px; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    font-size: 18px;
    color: #409EFF;
    line-height: 45px;
  }
  .descript-item:hover{
    background-color: #409EFF;
    color: white;
  }
  .active{
    background-color: #409EFF;
    color: white;
  }
  .file-con{
    margin-top: 50px;
    text-align: left;
  }
  .notice-item{
    height: 100px;
    margin-bottom: 20px;
  }
  .notice-item a:hover{
    background-color: #409EFF;
    color: white;
  }
  .notice-item a{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f7f7f7;
    color: #898888;
    border-radius: 5px;
    padding: 20px;
    text-decoration:none;
  }
  .notice-item-left{
    flex: 1;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .notice-desc{
    width: 400px;
    font-size: 18px;
    line-height: 24px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .notice-desc1{
    font-size: 14px;
    color:#898888;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .notice-item a:hover .notice-desc1{
    color: white;
  }
  .notice-item-right{
    width: 40px;
    height: 40px;
    background-image: url(../assets/pdf.png);
    background-position: center 0;
    background-repeat: no-repeat;
    background-size: 40px 40px;
  }
  .notice-item a:hover .notice-item-right{
    background-image: url(../assets/pdf1.png);
  }
  .toolbar{
    padding: 15px;
    background:#f3f3f3;
    color: #646464;
    position: relative;
    z-index: 1;
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

  }
  .pickerBox{
    width: 35%;
  }
  .inputBox{
    width: 59%;
    margin-left: 15px;
  }
  .search{
    width: 40px;
    height: 40px;
    margin-left: 15px;
    background: #409EFF;
  }
  .search img{
    width: 20px;
    height: 20px;
    margin: 10px;
  }
  .notice-total{
    margin: 20px 0 10px;
    color: #919191;
    text-align: left;
  }
  .item{
    width: 100%;
    height: 100px;
    position: relative;
    border-bottom: 1px solid #DCDFE6;
    cursor: pointer;
    text-align: left;
  }
  .item:hover{
    background-color: #DCDFE6;
  }
  .date{
    width: 60px;
    height: 56px;
    position: absolute;
    left: 10px;
    top: 25px;
    color: #b8b8b8;
    text-align: center;
  }
  .date::before{
    position: absolute;
    top: 50%;
    right: -20px;
    transform: translateY(-50%);
    content: '';
    display: block;
    width: 1px;
    height: 48px;
    background: #e4e4e4;
  }
  .hd{
    width: 60px;
    height: 40px;
    line-height: 1;
    font-size: 40px;
    color: #b8b8b8;
  }
  .fd{
    width: 60px;
    height: 16px;
    line-height: 1;
    font-size: 16px;
    color: #b8b8b8;
  }
  .text-main{
    position: absolute;
    top: 30px;
    left: 120px;
    color: #409EFF;
  }
  .txt{
    position: absolute;
    top:57px;
    left: 120px;
  }
  .more{
    width: 45px;
    height: 45px;
    position: absolute;
    top: 30px;
    right: 30px;
  }
  .Pagination{
    width: 100%;
    text-align: right;
    padding-top: 15px;
    position: relative;
  }
  .yeji{
    width: 80%;
    margin:0 auto;
    margin-top: 30px;
    width: 100%;
  }
  .tuanduiBox{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #b8b8b8;
    padding: 20px 0;
  }
  .tuanduiTit{
    width: 30%;
    font-size: 24px;
    color: #000000;
    line-height: 40px;
    text-align: center;
    text-align: left;
  }
  .tuanduiTxt{
    width: 60%;
    font-size: 18px;
    color: #4a4a4a;
    line-height: 40px;
    text-align: left;
    display: flex;
    flex-direction: column;
  }
  .tuanduiTxt p{
    height: 40px;
    display: inline-block;
    margin-right: 20px;
  }
  </style>
